import React from "react";
import MinusButton from "../assets/minus.svg";
import PlusButton from "../assets/plus.svg";
import "../App.css";
import BlueCheckbox from './resources/blueCheckbox';
import BadExample from "./BadExample";
import GoodExample from "./GoodExample";
import ReactTooltip from "react-tooltip";
import { generateId } from "../idGenerator";
import ReactGA from 'react-ga';

class Suggestion extends React.Component {

    constructor(props) {
        super(props);

        if (isNaN(this.props.id)) {
            this.id = generateId("suggestion-");
        } else {
            this.id = `suggestion-${this.props.id}`
        }

        this.state = { open: false, checked: false };
    }

    componentDidMount() {
        ReactTooltip.rebuild();
    }

    componentDidUpdate() {
        ReactTooltip.rebuild();
    }

    render() {
        const badExamples = [];
        const goodExamples = [];
        const otherChildren = [];

        React.Children.forEach(this.props.children, (child) => {
            if (child.type === BadExample) {
                const withListener = React.cloneElement(child, { onCopy: this.onBadExampleCopy.bind(this), key: generateId("badexample-") });
                badExamples.push(withListener);
            } else if (child.type === GoodExample) {
                const withListener = React.cloneElement(child, { onCopy: this.onGoodExampleCopy.bind(this), key: generateId("goodexample-") });
                goodExamples.push(withListener);
            } else {
                React.cloneElement(otherChildren.push(child), { key: generateId("otherchild-") });
            }
        });

        return <div className="StrategyTile" onClick={() => {
            if (!this.state.open) {
                this.setState({ open: true });
                this.sendOpenAnalytics();
            }
        }}>
            <div className="StrategyInstruction">
                <div className="StrategyMessage">
                    <BlueCheckbox
                        className="Checkbox"
                        value="box1"
                        checked={this.state.checked}
                        onClick={(event) => {
                            const previousOpenState = this.state.open;
                            this.setState({ checked: !this.state.checked, open: this.state.checked },
                                () => {
                                    if (this.state.checked) {
                                        this.sendCheckAnalytics();
                                        if (previousOpenState) {
                                            this.sendCloseAnalytics();
                                        }
                                    } else {
                                        this.sendUncheckAnalytics();
                                        if (!previousOpenState) {
                                            this.sendOpenAnalytics();
                                        }
                                    }
                                }
                            );
                            event.stopPropagation();
                        }}
                        data-tip="Tick the box once you have tried the suggestion."
                        data-for="checkbox-tooltip"
                        data-effect="solid"
                        data-place="right"
                    />
                    <div className="Suggestion">
                        {this.props.title}
                    </div>
                </div>
                {!this.state.open && (
                    <div
                        className="ButtonHolder"
                        data-tip="Open the suggestion."
                        data-for="openclose-tooltip"
                        data-effect="solid"
                        data-place="left"
                    >
                        <img
                            onClick={() => { this.setState({ open: true }); this.sendOpenAnalytics(); }}
                            src={PlusButton}
                            alt="down-button"
                            width="20"
                            height="20"
                        ></img>
                    </div>
                )}
                {this.state.open && (
                    <div
                        className="ButtonHolder"
                        data-tip="Close the suggestion."
                        data-for="openclose-tooltip"
                        data-effect="solid"
                        data-place="left"
                    >
                        <img
                            onClick={() => { this.setState({ open: false }); this.sendCloseAnalytics(); }}
                            src={MinusButton}
                            alt="up-button"
                            width="20"
                            height="20"
                        ></img>
                    </div>
                )}
            </div>
            {this.state.open && (
                <div className="CodeExample">
                    <div className="CodeContainer">
                        <div className="ExampleTitle">Incorrect Example{badExamples.length > 1 ? "s" : ""}</div>
                        {badExamples}
                    </div>
                    <div className="CodeContainer">
                        <div className="ExampleTitle">Correct Example{goodExamples.length > 1 ? "s" : ""}</div>
                        {goodExamples}
                    </div>

                    {otherChildren}
                </div>
            )}
        </div>;
    }

    onBadExampleCopy() {
        this.sendAnalytics("badexample-copy");
    }

    onGoodExampleCopy() {
        this.sendAnalytics("goodexample-copy");
    }

    sendOpenAnalytics() {
        this.sendAnalytics("open");
    }

    sendCloseAnalytics() {
        this.sendAnalytics("close");
    }

    sendCheckAnalytics() {
        this.sendAnalytics("check")
    }

    sendUncheckAnalytics() {
        this.sendAnalytics("uncheck");
    }

    sendAnalytics(action) {
        ReactGA.event({
            category: "suggestion-interaction",
            label: `${window.location.pathname}-${this.id}`,
            action: action
        });
    }
}

export default Suggestion;
